// @ts-nocheck
import useAllowZeroPricing from "@store/Framework/Store/Data/Products/ProductsHooks/useAllowZeroPricing";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductModel, ProductSettingsModel } from "@insite/client-framework/Types/ApiModels";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

/* Bunzl Custom Code - Start */
import useIsProductRestricted from "@store/Framework/Store/Data/Products/ProductsHooks/useIsProductRestricted";
/* Bunzl Custom Code - End */

export default (
    product: ProductModel,
    productSettings: ProductSettingsModel,
    productInfo?: ProductInfo,
    hasEnoughInventory?: boolean | null,
    configurationCompleted?: boolean,
    variantSelectionCompleted?: boolean,
    allowBackOrder?: boolean,
) => {
    const allowZeroPricing = useAllowZeroPricing();
    const isRestricted = useIsProductRestricted(product); // Bunzl Custom Code

    const preventAddToCart = getBooleanProperty(productInfo?.inventory?.additionalResults?.preventAddToCart);
    const availability =
        productInfo?.inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (productInfo?.unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    const hasStock = availability && availability.messageType !== 2;
    const canAddToCart =
        !product.cantBuy &&
        (product.canAddToCart ||
            ((configurationCompleted || variantSelectionCompleted) &&
                (allowBackOrder || hasStock) &&
                !product.canConfigure));

    if (!product || preventAddToCart || !allowZeroPricing || isRestricted /* Bunzl Custom Code */) {
        return false;
    }

    if (productSettings.canAddToCart && hasEnoughInventory && canAddToCart) {
        if (!product.isVariantParent || (product.isVariantParent && variantSelectionCompleted !== undefined)) {
            return true;
        }
    }

    return false;
};
